export const SortIcon = () => {
  return (
    <svg
      width="10"
      height="8"
      viewBox="0 0 10 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.103984 5.55414C-0.0317112 5.68583 -0.0350535 5.90241 0.096631 6.0381L1.41281 7.39472C1.41289 7.3948 1.41302 7.39484 1.4131 7.39493C1.47531 7.45931 1.56175 7.5 1.65846 7.5C1.75518 7.5 1.84162 7.45931 1.90383 7.39493C1.90391 7.39484 1.90403 7.3948 1.90412 7.39472L3.22063 6.0381C3.35231 5.90241 3.34897 5.68583 3.21328 5.55414C3.07758 5.42246 2.861 5.4258 2.72932 5.5615L2.00071 6.3124V0.842246C2.00071 0.653075 1.84763 0.5 1.65846 0.5C1.46929 0.5 1.31622 0.653075 1.31622 0.842246V6.31229L0.587941 5.5615C0.456257 5.4258 0.239679 5.42246 0.103984 5.55414Z"
        fill="#002D56"
      />
      <path
        d="M8.51461 2.94686C8.51461 2.75769 8.36153 2.60461 8.17236 2.60461H4.45846C4.26929 2.60461 4.11621 2.75769 4.11621 2.94686C4.11621 3.13603 4.26929 3.28911 4.45846 3.28911H8.17236C8.36153 3.28911 8.51461 3.13603 8.51461 2.94686Z"
        fill="#002D56"
      />
      <path
        d="M7.44676 5.05181C7.44676 4.86264 7.29368 4.70956 7.10451 4.70956H4.45846C4.26929 4.70956 4.11621 4.86264 4.11621 5.05181C4.11621 5.24098 4.26929 5.39406 4.45846 5.39406H7.10451C7.29368 5.39406 7.44676 5.24098 7.44676 5.05181Z"
        fill="#002D56"
      />
      <path
        d="M4.45846 6.81552C4.26929 6.81552 4.11621 6.9686 4.11621 7.15777C4.11621 7.34694 4.26929 7.50001 4.45846 7.50001H6.03667C6.22584 7.50001 6.37891 7.34694 6.37891 7.15777C6.37891 6.9686 6.22584 6.81552 6.03667 6.81552H4.45846Z"
        fill="#002D56"
      />
      <path
        d="M9.24021 0.5H4.45846C4.26929 0.5 4.11621 0.653075 4.11621 0.842246C4.11621 1.03142 4.26929 1.18449 4.45846 1.18449H9.24021C9.42938 1.18449 9.58245 1.03142 9.58245 0.842246C9.58245 0.653075 9.42938 0.5 9.24021 0.5Z"
        fill="#002D56"
      />
    </svg>
  );
};
